import React from 'react';
import { View } from 'framework7-react';

import style from './style';

const MainView = () => <View main url={'/'} style={style.mainView} />;

export default MainView;
